import gql from 'graphql-tag'

export const DASHBOARD = gql`
  query accountDashboard {
    person {
      id
      uuid
      firstAccess
      name
      email
      personStatusId
      pisco {
        code
        hasAccess
      }
      parents {
        email
        name
        isAuthorized
        isConfirmedRelation
      }
      services {
        id
        name
      }
      roles {
        id
        name
        schools {
          id
          tradeName
          roleStatus {
            name
            id
          }
        }
      }
    }
  }
`
export const MANAGEABLE_SCHOOLS = gql`
  query accountManageableSchools {
    person {
      schools(isManageable: true) {
        id
        tradeName
      }
    }
  }
`
export const PERSONAL_DATA = gql`
  query accountPersonalData {
    person {
      id
      firstAccess
      name
      email
      personStatusId
      cpf
      publicCode
      byIntegration
      canChangePassword
      externalReference(appId: [306, 364, 309]) {
        applicationId
      }
      parents {
        email
        name
        isAuthorized
        isConfirmedRelation
      }
      users {
        id
        username
        personId
        typeUserId
      }
      contacts {
        ddd
        number
      }
      pisco {
        code
        hasAccess
      }
      roles {
        id
        name
      }
      schools {
        id
        tradeName
        isManageable
        metadata(id: [NOT_ALLOW_CATCH_RESPONSIBLE_EMAIL]) {
          value
        }
        externalReference(appId: 215) {
          applicationName
        }
      }
    }
  }
`
export const PERSON_VALID_SCHOOLS = gql`
  query accountPersonValidSchools($applicationId: [Int!]) {
    person {
      byIntegration
      externalReference(appId: $applicationId) {
        applicationId
      }
      schools {
        id
        tradeName
        legalName
        byIntegration
        accessCode
        brands {
          name
        }
        levels {
          id
          name
        }
        brands {
          name
        }
      }
      roles(status: [ACTIVE, DISAPPROVED, PENDING_APPROVE]) {
        id
        name
        classes(
          orderBy: [PERIOD_YEAR_ASC, LEVEL_NAME_ASC, GRADE_NAME_ASC, NAME_ASC]
          status: "ATIVO"
          positionClassStatusId: 3
        ) {
          id
          name
          schoolId
          periodId
          status
          personClassStatusId
          period {
            year
          }
          teacherDisciplines(status: [ACTIVATED]) {
            id
            name
          }
          levelGrades {
            id
            gradeName
          }
        }
        schools {
          id
          tradeName
          legalName
          roleStatus {
            name
            id
          }
        }
        levels(orderBy: [LEVEL_NAME_ASC]) {
          id
          name
        }
      }
    }
  }
`
export const PERSON_SCHOOL_ROLES = gql`
  query accountSchoolRoles($schoolId: Int!, $positionClassStatusId: Int!) {
    person {
      roles(schoolId: $schoolId) {
        id
        name
        levels {
          id
          name
        }
        classes(
          positionClassStatusId: $positionClassStatusId
          orderBy: [LEVEL_NAME_ASC, GRADE_NAME_ASC, NAME_ASC]
        ) {
          id
          name
          teacherDisciplines(status: [ACTIVATED]) {
            id
            name
          }
        }
        schools {
          id
          tradeName
          roleStatus {
            name
            id
          }
        }
      }
    }
  }
`
export const GET_ROLES = gql`
  query accountListRoles {
    listRoles {
      id
    }
  }
`
export const GET_LEVELS_VOUCHER = gql`
  query accountGetLevels($accessCode: String!) {
    school(accessCode: $accessCode) {
      id
      tradeName
      levels {
        id
        name
      }
    }
  }
`
export const GET_ACTIVE_PERIODS = gql`
  query accountGetActivePeriods {
    listPeriods(periodStatusId: 1) {
      id
      year
    }
  }
`
export const GET_CLASSES_TOTAL_COUNT_VOUCHER = gql`
  query accountGetClassesTotal($accessCode: String!, $periodIds: Int!) {
    person {
      id
      name
    }
    school(accessCode: $accessCode) {
      id
      tradeName
      classes(first: 1, periodIds: $periodIds) {
        totalCount
      }
    }
  }
`
export const PERSON_USED_ACCESS_CODES = gql`
  query accountUsedAccessCodes {
    person {
      schools {
        id
        tradeName
        isManageable
      }
      usedAccessCodes {
        accessCode
        createdAt
        products {
          id
          title
        }
        class {
          school {
            tradeName
          }
        }
        school {
          tradeName
        }
      }
    }
  }
`
export const PERSON_CLASS_AND_DISCIPLINES = gql`
  query personClassAndDisciplines(
    $schoolId: Int!
    $positionClassStatusId: Int!
    $periodIds: [Int!]
  ) {
    person {
      roles(schoolId: $schoolId) {
        id
        name
        levels(orderBy: [LEVEL_NAME_ASC]) {
          id
          name
          disciplines {
            id
            name
            classes(
              status: "ATIVO"
              positionClassStatusId: $positionClassStatusId
              orderBy: [PERIOD_YEAR_ASC, LEVEL_NAME_ASC, GRADE_NAME_ASC, NAME_ASC]
              periodIds: $periodIds
            ) {
              id
              name
              status
              personClassStatusId
              period {
                id
                year
              }
              levelGrades {
                gradeName
              }
            }
          }
          grades {
            id
            name
            knowlegedAreas {
              id
              name
              disciplines {
                id
                name
                classes {
                  id
                  name
                  period {
                    id
                    year
                  }
                }
              }
            }
          }
        }
        schools {
          id
          tradeName
          roleStatus {
            name
            id
          }
        }
      }
    }
  }
`
export const GET_PERSON_RESPONSIBLE_DEPENDENTS = gql`
  query personResponsibleDependents {
    person {
      id
      dependents {
        id
        name
        person {
          schools {
            tradeName
            legalName
            studentData {
              classes(status: "ATIVO", positionClassStatusId: 3) {
                levelGrades {
                  levelName
                }
              }
            }
          }
        }
      }
    }
  }
`
export const GET_DEPENDENT_BY_PUBLIC_CODE = gql`
  query dependentByPublicCode($publicCode: String!) {
    person(publicCode: $publicCode) {
      uuid
      name
    }
  }
`
export const GET_PRIVACY_PREFERENCES = gql`
  query ($input: MeInput!) {
    me(input: $input) {
      privacyPreferences {
        somosId
        type
        hasSchoolBlock
        channels {
          channel
          optOutDate
        }
      }
    }
  }
`

export const GET_TERM_OF_USE = gql`
  query accountGetTermOfUse($id: Int!) {
    termOfUse(id: $id) {
      id
      name
      title
      content
      publicationDate
    }
  }
`

export const GET_TERMS_OF_USE = gql`
  query accountGetTermsOfUse($url: String!) {
    person {
      applications(url: $url) {
        termsOfUse {
          id
          accepted
        }
      }
    }
  }
`
